import React from 'react'
import { useKeycloak } from '@react-keycloak/web'
import RectangleActionButton, { SIZE_BIG } from '../genericComponents/buttons/RectangleActionButton'
import { TAG_CLICK_USER_LOGIN_BUTTON } from '../../store/analytics/analytics.actionTypes'
import { withUserKnown } from './shared/withKeycloak'
import { useSelector } from 'react-redux'
import { selectPrevFullRouteNonPageLess } from '../../store/history/history.selectors'

const UserLoginButton = ({ size = SIZE_BIG }) => {
  const { keycloak } = useKeycloak()

  const lastFullRoute = useSelector(selectPrevFullRouteNonPageLess)

  const loginUrl = keycloak.createLoginUrl({ redirectUri: `${location.origin}${lastFullRoute}` })

  return (
    <RectangleActionButton
      tagData={{ type: TAG_CLICK_USER_LOGIN_BUTTON }}
      nofollow
      size={size}
      label="Connexion / Inscription"
      href={loginUrl}
    />
  )
}

export default withUserKnown(UserLoginButton)
